import axios from 'axios'
import store from '@/store/index'
// import { Spin } from 'iview'
const addErrorLog = errorInfo => {
    const {statusText, status, request: {responseURL}} = errorInfo;
    let info = {
        type: 'ajax',
        code: status,
        mes: statusText,
        url: responseURL
    };
    if (!responseURL.includes('save_error_logger')) store.dispatch('addErrorLog', info)
};

class HttpRequest {
    constructor(baseUrl = baseURL) {
        this.baseUrl = baseUrl;
        this.queue = {}
    }

    getInsideConfig(options) {
        const config = {
            baseURL: this.baseUrl,
            headers: {}
        };
        config.headers['Authorization'] = store.state.user.token;
        return config
    }

    destroy(url) {
        delete this.queue[url];
        if (!Object.keys(this.queue).length) {
            // Spin.hide()
        }
    }

    interceptors(instance, url) {
        // 请求拦截
        instance.interceptors.request.use(config => {
            // 添加全局的loading...
            if (!Object.keys(this.queue).length) {
                // Spin.show() // 不建议开启，因为界面不友好
            }
            this.queue[url] = true
            return config
        }, error => {
            return Promise.reject(error)
        });
        // 响应拦截
        instance.interceptors.response.use((res) => {
            this.destroy(url);
            const {data, status} = res;
            if (res.headers.hasOwnProperty('authorization')) {
                store.commit('setToken', res.headers.authorization)
            }
            if (res.data.code === "400002" || res.data.code === "400003" || res.data.code === "400004" || res.data.code === "400005") {
                store.commit('setToken', '');
                store.commit('setHasGetInfo', false);
            }
            return {data, status}
        }, error => {
            this.destroy(url);
            let errorInfo = error.response;
            if (!errorInfo) {
                const {request: {statusText, status}, config} = JSON.parse(JSON.stringify(error));
                errorInfo = {
                    statusText,
                    status,
                    request: {responseURL: config.url}
                }
            }
            addErrorLog(errorInfo);
            return Promise.reject(error)
        })
    }

    request(options) {
        const instance = axios.create();
        options = Object.assign(this.getInsideConfig(options), options);

        this.interceptors(instance, options.url);
        return instance(options)
    }
}

export default HttpRequest
